/*
 * @license
 * Copyright Endlessjs. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */

import { NgModule } from '@angular/core';

import { ElSharedModule } from '../shared/shared.module';
import { ElOverlayModule } from '../cdk/overlay/overlay.module';
import { ElIconModule } from '../icon/icon.module';

import { ElTooltipComponent } from './tooltip.component';
import { ElTooltipDirective } from './tooltip.directive';


@NgModule({
  imports: [ElSharedModule, ElOverlayModule, ElIconModule],
  declarations: [ElTooltipComponent, ElTooltipDirective],
  exports: [ElTooltipDirective],
  entryComponents: [ElTooltipComponent],
})
export class ElTooltipModule {
}
